import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'
import { surveyEntryStatIconImgSx } from '../styles/surveyEntryStyles'

interface SurveyEntryStatIconProps {
  readonly src: string
  readonly testId?: string
  readonly sx?: SxProps<Theme>
}

/** Figma 5074-14050 / 14060 / 14068 — 24×24 vuesax icons inside stat card wrap. */
export function SurveyEntryStatIcon({ src, testId, sx }: SurveyEntryStatIconProps) {
  return (
    <Box
      component="img"
      src={src}
      alt=""
      aria-hidden
      sx={{ ...surveyEntryStatIconImgSx, ...sx }}
      data-testid={testId}
    />
  )
}
